"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationSessionCreateDto = instanceOfOrientationSessionCreateDto;
exports.OrientationSessionCreateDtoFromJSON = OrientationSessionCreateDtoFromJSON;
exports.OrientationSessionCreateDtoFromJSONTyped = OrientationSessionCreateDtoFromJSONTyped;
exports.OrientationSessionCreateDtoToJSON = OrientationSessionCreateDtoToJSON;
exports.OrientationSessionCreateDtoToJSONTyped = OrientationSessionCreateDtoToJSONTyped;
/**
 * Check if a given object implements the OrientationSessionCreateDto interface.
 */
function instanceOfOrientationSessionCreateDto(value) {
    if (!('startTime' in value) || value['startTime'] === undefined)
        return false;
    if (!('endTime' in value) || value['endTime'] === undefined)
        return false;
    return true;
}
function OrientationSessionCreateDtoFromJSON(json) {
    return OrientationSessionCreateDtoFromJSONTyped(json, false);
}
function OrientationSessionCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startTime': (new Date(json['startTime'])),
        'endTime': (new Date(json['endTime'])),
    };
}
function OrientationSessionCreateDtoToJSON(json) {
    return OrientationSessionCreateDtoToJSONTyped(json, false);
}
function OrientationSessionCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'startTime': ((value['startTime']).toISOString()),
        'endTime': ((value['endTime']).toISOString()),
    };
}
//# sourceMappingURL=OrientationSessionCreateDto.js.map